// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__RwvjW","titleRow":"css_titleRow__n9aIo","capacityRow":"css_capacityRow__Mtbl8","buttonsList":"css_buttonsList__9t8QJ","iconButton":"css_iconButton__7Wx1Q"};